/* eslint-disable max-len */
/* eslint-disable no-console */
/**
 * API_Name: Get_All_Trash_Data
 * Type: Custome Hooks
 */
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTrashFolders } from '../../actions/media_actions';
import { setMediaKitData } from '../../../redux/MediakitRedux';
import { MediaContext } from '..';

const useFetchTrash = () =>
{
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { mediaState, setMediaState, tab } = useContext(MediaContext);
	const { trashData } = useSelector((state:any) => state?.mymediakit?.mediaKitData);
	const dispatch = useDispatch();

	const query: any = {
		uid     : userData?.userId,
		comid   : userData?.companyId,
		empRole : userData?.empRole,
		role    : userData?.role,
		limit   : 12,
		skip    : mediaState?.page
	};

	if ([ 1, -1 ].includes(mediaState?.sort)) query.sortByName = mediaState.sort;

	const getCount = async () =>
	{
		query.count = true;

		try
		{
			const response = await getTrashFolders(query);

			if (response?.status)
			{
				setMediaState({ type: 'setCount', payload: { trash: response?.count } });
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	let trashPromise;

	const getTrashDataInfo = async () =>
	{
		mediaState?.page === 0 && (trashData?.length === 0 || mediaState?.searchValue) && setMediaState({ type: 'updateReducer', payload: { loading: true } });
		if (mediaState?.searchValue)
		{
			query.search = mediaState?.searchValue;
		}
		try
		{
			trashPromise = getTrashFolders(query);
			const response = await trashPromise;

			if (response?.status)
			{
				tab === 3 && mediaState?.page === 0 && (response?.data?.length >= 12 ? getCount() : setMediaState({ type: 'setCount', payload: { trash: response?.data?.length } }));
				dispatch(setMediaKitData({ trashData: mediaState?.page > 0 ? [ ...trashData, ...response.data ] : response?.data }));
			}
			setMediaState({ type: 'updateReducer', payload: { loading: false } });
		}
		catch (err)
		{
			console.log('error: ', err);
			setMediaState({ type: 'updateReducer', payload: { loading: false } });
		}
	};

	return getTrashDataInfo;
};

export default useFetchTrash;